module.exports = __webpack_public_path__ + "media/images/appTitle-0da629de35d23b891e3e1d99d9b586c6.svg";